import type { HTMLAttributes, InputHTMLAttributes } from 'vue'
import type { MaskInputOptions, MaskTokens } from 'maska'

export interface InputTextProps<T extends string | number> {
  autocomplete?: string | undefined
  placeholder?: string
  modelValue?: T
  value?: T
  id?: string
  name: InputHTMLAttributes['name']
  label?: string
  maxLength?: string | number
  disabled?: boolean
  controlled?: boolean
  leftIcon?: string
  rightIcon?: string
  prefix?: string
  suffix?: string
  type?: HTMLInputElement['type'] | 'currency' | 'percentage'
  inputmode?: HTMLAttributes['inputmode']
  inputClass?: HTMLAttributes['class']
  readOnly?: HTMLInputElement['readOnly']
  clearable?: boolean
  syncVModel?: boolean
  description?: string
  tooltipText?: string
  applyMaska?: boolean
  dataMaska?: string
  dataMaskaOptions?: MaskInputOptions
  dataMaskaTokens?: MaskTokens
  enterkeyhint?: string
  compact?: boolean
  textSizeClass?: string
  hideError?: boolean
}

export interface ProgressSpinnerProps {
  color?: 'current' | 'white' | 'black' | 'gold'
  width?: number | string
  height?: number | string
  centered?: boolean
}

export type MenuProps = {
  items?: any[]
  modelValue?: any
  multiple?: boolean
  searchValue?: string
  searchKey?: string[]
  searchable?: boolean
  searchPlaceholder?: string
  menuVisible: boolean
  fullWidth?: boolean
  noResultText?: string
  valueKey: string
  itemSize?: number
  menuWidth?: CSSStyleDeclaration['width']
  menuHeight?: CSSStyleDeclaration['height']
  customContent?: boolean
  loading?: boolean
  compact?: boolean
  groups?: boolean
  avatar?: boolean
}

export type PhoneCountryOption = {
  iso2: string
  name: string
  phone_code: string
  id: number
}

export type Phone = {
  number?: number
  country?: PhoneCountryOption
}

export type Tab = {
  id: string
  text: string
  disabled?: boolean
  icon?: string
  permissions?: string[]
  url?: string
}

export interface InputItem {
  id?: any
  value: any
  text: string
  icon?: string
  disabled?: boolean
  important?: boolean // if true, show before the others
  condition?: Function
}

export interface TableColumn extends Omit<InputItem, 'value'> {
  sortable?: string
  slot?: string
  sticky?: boolean
  stickyRight?: boolean
  width?: string
  isStatic?: boolean
  value?: any
  unselectedByDefault?: boolean
  tooltip?: string
}

export type Pagination = {
  current_page: number
  total_pages: number
  last_page: number
  total: number
  count: number
  per_page: number
}

export type CommonFilters = {
  orderBy?: string
  sortedBy?: 'asc' | 'desc' | ''
}

export type CommonAction = {
  text: string
  action: string
}

export type SidebarItem = {
  id: string
  text: string
  icon?: string
  link?: string
  active?: boolean
  disabled?: boolean
  class?: string
  action?: () => void
}

export type LibraryItem = {
  id: number
  name: string | null
  code: string | null
  colorCode: string | null
  description: string | null
}

export type DateRange = {
  start?: Date
  end?: Date
}

export type AdditionalFilter = {
  id: string
  name: string
  enabled: boolean
  items: any[] | undefined
  loading: boolean
  props?: {
    [key: string]: any
  }
  component?: Component
}

export type TableUpperHeader = {
  text?: string
  columns?: number
  sticky?: boolean
  stickyRight?: boolean
  value?: string
  tooltip?: string
}

export type TableAdditionalRowClass = {
  keys: string[]
  value: any
  class: string
}

export type DynamicComponent = {
  value: boolean
  component: Component | undefined
  data: object
  events: object
  animation: string
}

export type SnackTypes = 'info' | 'error' | 'success'

export type SnackBanner = {
  id: number
  type: SnackTypes
  text: string
}

export enum FILTERS {
    USERS = 'users',
    PROPERTIES = 'properties',
    TRAININGS = 'trainings',
    EXPLORE = 'explore',
  }
  